import { RendererContextType } from '../../../../contexts/RendererContext';
import { ProjectByIdQuery } from '../../../../types/graphqlTypes';
import { PointCluster } from '../../../../potree/utils/PointCluster';
import { SyncConfig } from './syncFromGraphQL';

type Project = ProjectByIdQuery['projectById'];
type Annotation = Project['state']['annotations'][number];

export function createSyncPointClustersConfig({ viewer, annotations }: { viewer: NonNullable<RendererContextType['viewer']>; annotations: Annotation[] }): SyncConfig<Annotation, PointCluster> {
  return {
    getSourceItems: () => annotations.filter((a) => a.type === 'POINTCLUSTER'),
    getSceneItems: () => viewer.scene.pointClusters.filter((pc) => pc.finished),
    getSourceIdentifier: (item) => item.identifier,
    getSceneIdentifier: (item) => item.identifier,
    // update() omitted — geometry updates are handled by reactive property subscriptions
    create: (source, existing) => {
      // PointCluster constructor auto-calls loadReactiveProperties() which loads segments from property system
      const pointCluster = new PointCluster({
        identifier: source.identifier,
        selected: existing?.selected || false,
      });
      pointCluster.finish();
      return pointCluster;
    },
    addToScene: (item) => viewer.scene.addPointCluster(item),
    removeFromScene: (item) => viewer.scene.removePointCluster(item),
  };
}
